
import React, {Component} from 'react';
import {Tab, Tabs} from 'material-ui';
import {toastr} from 'react-redux-toastr';
import {connect} from 'react-redux';
import {setUserEditTab} from '../layout/actions';
import UserEdits from './UserEdits';
import UserPermissions from './UserPermissions';
import {fetchUser} from './thunks';
import UserEditIcon from 'material-ui-icons/Accessibility';
import UserPermissionsIcon from 'material-ui-icons/SupervisorAccount';

class UserEditTabs extends Component {

    componentWillMount() {
        this.props.fetchUser(this.props.match.params.id);
    }

    componentWillUnmount() {
        toastr.removeByType('error');
    }

    handleChange = (event, value) => {
        this.props.setUserEditTab(value, this.props.match.params.id);
    };

    render() {
        const {activeTabData, user} = this.props;

        let activeTab = 0;

        if (activeTabData[this.props.match.params.id]) {
            activeTab = activeTabData[this.props.match.params.id];
        }

        return (
            <div>
                <Tabs
                    value={activeTab}
                    onChange={this.handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                >
                    <Tab icon={<UserEditIcon />} label="User Roles, Sites & Languages" />
                    <Tab icon={<UserPermissionsIcon />} label="User Permissions" />
                </Tabs>
                {activeTab === 0 && user &&
                    <UserEdits
                        userName={user.name}
                        userId={this.props.match.params.id}
                    />
                }
                {activeTab === 1 && user &&
                    <UserPermissions
                        userName={user.name}
                        userId={this.props.match.params.id}
                    />
                }
            </div>
        )
    }
}

const mapStateToProps = (state, props) => ({
    activeTabData: state.layout.activeUsersEditTab,
    user: state.users.user,
});

export default connect(mapStateToProps, {
    setUserEditTab,
    fetchUser,
})(UserEditTabs);



// WEBPACK FOOTER //
// ./src/containers/users/UserEditTabs.jsx